module.exports = __webpack_public_path__ + "img/safe_work_splash.c907d8b5.jpg";